import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { Router } from '@angular/router';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';

/**
 * Constant import.
 */
import { EVENT_NAME } from '../../../analytics-event/analytics.constant';
import { SCREEN_NAME, NUMBERS, NUDGE_IDENTIFIERS, BRANCH_IDENTIFIER } from '../../../constants/app.constants';

/**
 * RxJS imports
 */
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../../analytics-event/analytics.model';
@Component({
  selector: 'app-generic-card',
  templateUrl: './generic-card.component.html',
  styleUrls: ['./generic-card.component.scss']
})
export class GenericCardComponent implements OnInit, OnDestroy {


  @Output() emitButtonClicked: EventEmitter<null> = new EventEmitter();
  @Input() dataObj;
  @Input() callingfrom;
  feedDetailModal = false;
  mediaIdx = 0;
  isShownWebModal = false;
  displaySection = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  product_id: any;
  displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };
  /**
   * Analytic data.
   */
  public analyticsData: AnalyticsInterface;

  /**
   * Used to store nudge identifier.
   */
  public nudgeIdentifier = NUDGE_IDENTIFIERS;

  /**
   * @notifier$ defines a notifier subject stream to end data streaming
   */
  private notifier$ = new Subject();

  constructor(private dss: DataStorageService, public fcs: FunCollectionService, private router: Router, private masterSer: MasterserviceService, public mls: NewLanguageService, private postService: PostApiService, private jwtService: JwtDecodeService) { }

  /**
   * Set analytics data.
   */
  ngOnInit(): void {
    this.analyticsData = {
      'event_name': EVENT_NAME.PROFILE_NUDGE_CLICK,
      'product_type': 0,
      'product_type_id': 0,
      'screen_name': SCREEN_NAME.GRAND_ROUND
    };
  }

  showWebModal(): void {
    this.emitButtonClicked.emit();
    let type = '';
    if (this.dataObj.button.target != null) {
      type = this.dataObj.button.target.type;

    } else {
      type = this.dataObj.type;
    }

    if (type == 'feed') {
      this.product_id = this.dataObj.button.target.id;

      this.showFeedDetail();
    } else if (type == 'cme') {
      this.product_id = this.dataObj.button.target.id;

      this.router.navigateByUrl('cme/detail/' + this.product_id);
    }
    else if (type == 'channel') {
      this.product_id = this.dataObj.button.target.id;

      this.router.navigateByUrl('cme/channel/' + this.product_id);
    }
    else if (type == 'gr_filter') {
      const filter = JSON.parse(this.dataObj.button.target.url);
      this.dss.feed_filter.next(filter);

    }
    else if (type == 'profile_incompleted') {
      this.fcs.navigateToUserProfie(this.dss.user_profile_data.profile.custom_id);
    }
    else if (type == 'link') {
      window.open(this.dataObj.button.target.url, '_blank');
      // console.log(this.dataObj.button.target.url)
    } else if (type === BRANCH_IDENTIFIER.COMMUNITY_LIST) {
      this.fcs.redirectOnSection(type, this.dataObj.button.target.id);
    } else if (type === BRANCH_IDENTIFIER.COMMUNITY_CREATE) {
      this.fcs.redirectOnSection(type, this.dataObj.button.target.id);
    }
    else if (type == this.nudgeIdentifier.GAME_DETAIL) {
      this.fcs.navigateToGameDetail(this.dataObj.button.target.id);
    }
    else if (type == this.nudgeIdentifier.NCP_SUBTYPE) {
      this.postService.updatePlayCount(this.dataObj.button.target.id).
        pipe(takeUntil(this.notifier$)).
        subscribe(response => {
          this.jwtService.decodeData(response).then(data => {
            if (data['status'] === NUMBERS.ONE) {
              this.fcs.navigateToGameScreen(this.dataObj.button.target.id);
            } else if (data['status'] === NUMBERS.ZERO) {
              // No Code
            }
          }, error => {
            console.log(error);
          });
        });
    }
    else if (type == this.nudgeIdentifier.NCP_DETAIL) {
      this.fcs.navigateToNCPDetail(this.dataObj.button.target.id);
    }
  }

  showFeedDetail(): void {
    if (this.fcs.device_detail.is_desktop != true) {
      this.router.navigateByUrl('web/detail/' + this.product_id);
      //this.feedDetailModal=true;
    }
    else {
      this.mediaIdx = 0;
      this.feedDetailModal = true;
    }

  }

  resetFeedDetailModal(): void {
    this.mediaIdx = 0;
    this.feedDetailModal = false;
  }

  /**
   * @EventHandler to clean up memory/Event handler/subscription
   */
  ngOnDestroy(): void {
    this.notifier$.next();
    this.notifier$.complete();
  }
}
